import _ from 'lodash';
import Vue from 'vue';

export default message => e => {
    Vue.prototype.$message.error(_.get(e, 'message', message));
    return e;
};
